import { Component } from '@angular/core';
import { ConnectionPointService, SortDirection } from '@app/api/nts';
import { ExpiringConnectionRightDto } from '@app/api/nts/model/expiringConnectionRightDto';
import { SortDir } from '@app/core/constants/sort-dir';
import { SortParam } from '@app/core/constants/sort-param';
import { HeaderService } from '@app/core/services/header.service';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { LinkCellComponent } from '@shared/components/table/cells/link-cell/link-cell.component';
import { TableComponent } from '@shared/components/table/table.component';
import { Columns } from '@shared/interfaces/table/column-config';
import { TableConfig } from '@shared/interfaces/table/table-config';

@Component({
  selector: 'app-dashboard-expiring-connection-rights',
  imports: [TableComponent],
  templateUrl: './dashboard-expiring-connection-rights.component.html',
})
export class DashboardExpiringConnectionRightsComponent {
  private currentSort?: SortParam;

  public tableConfig: TableConfig<ExpiringConnectionRightDto> = {
    id: 'table-dashboard-expiring-connection-rights',
    title: 'dashboard.connectionright.expiring.title',
    columns: [
      {
        title: 'connectionpoint.identification',
        key: 'connectionPointIdentification',
        cellRenderer: LinkCellComponent,
        cellRendererParams: {
          url: '/connectionpoint',
          urlReference: 'connectionPointIdentification',
        },
      },
      {
        title: 'dashboard.table.meterframeid',
        key: 'meterFrameIdentification',
      },
      {
        title: 'dashboard.connectionright.expiring.date',
        key: 'expiresAt',
        cellRenderer: DateCellComponent,
      },
    ] satisfies Columns<ExpiringConnectionRightDto>[],
    activeColumns: ['connectionPointIdentification', 'meterFrameIdentification', 'expiresAt'],
    pagination: true,
    selectable: false,
    fetchOnLoad: true,
    serviceCallback: (pageSize, page, sort) => {
      if (sort) this.currentSort = sort;
      return this.connectionPointService.connectionPointConnectionRightsExpiringPost({
        page,
        pageSize,
        sortParameters: this.currentSort ? [{
          sortField: this.currentSort.sortField,
          sortDirection: this.currentSort.sortDirection === SortDir.desc
            ? SortDirection.Descending
            : SortDirection.Ascending,
          order: 1,
        }] : undefined,
      });
    },
  };

  constructor(
    private readonly connectionPointService: ConnectionPointService,
    private readonly headerService: HeaderService,
  ) {
    this.headerService.setTitle('dashboard.connectionright.expiring.title');
  }
}
